import { useCallback, useState } from 'react'

interface ReturnType<T> {
  hiddenTraces: T[]
  onSetHiddenTraces: (traces: T[]) => void
  toggleTraceVisibility: (trace: T) => void
}

/**
 * This hook provides logic for hidden (deselected) traces in a chart.
 */
const useHideTraces = <T>(): ReturnType<T> => {
  const [hiddenTraces, setHiddenTraces] = useState<T[]>([])

  const onSetHiddenTraces = (traces: T[]): void => {
    setHiddenTraces(traces)
  }

  const toggleTraceVisibility = useCallback(
    (trace: T) => {
      const isTraceHidden = hiddenTraces.includes(trace)
      if (isTraceHidden) {
        setHiddenTraces(hiddenTraces.filter(hiddenTrace => hiddenTrace !== trace))
      } else {
        setHiddenTraces([...hiddenTraces, trace])
      }
    },
    [hiddenTraces]
  )

  return { hiddenTraces, onSetHiddenTraces, toggleTraceVisibility }
}

export default useHideTraces
